import { Component, OnDestroy, OnInit } from '@angular/core'
import { SelectItem } from 'primeng/api'
import { TableData } from '../../models/table-data'
import { DtoEntitiesState } from '../../../../models/site-state/dto-entities-state.model'
import { ActivatedRoute, Router } from '@angular/router'
import { BaseNavStateComponent } from '../../../../modules/navigation-state/components/base-component/base-nave-state.component'
import { JmlNavAdapterService, JmlUrlParamService } from '../../../../modules/navigation-state'
import { filter, map, take, tap } from 'rxjs/operators'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { JmlTitleService } from '../../../../services/jml-title.service'
import { EntityConfigService } from '../../services/entity-config.service'

@Component({
  selector: 'jml-lib-dto-entities',
  templateUrl: './dto-entities.component.html',
  styleUrls: ['./dto-entities.component.scss']
})
export class DTOEntitiesComponent extends BaseNavStateComponent<DtoEntitiesState> implements OnInit, OnDestroy {
  data: TableData
  dtoConfigs: SelectItem[]
  currentConfig: string
  entityId$: Observable<number>
  entityType$: Observable<string>
  subscriptions: Subscription[] = []
  isDetailView: boolean

  constructor(
    private jmlUrlParamService: JmlUrlParamService,
    jmlNav: JmlNavAdapterService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: JmlTitleService,
    private entityConfigService: EntityConfigService
  ) {
    super(jmlNav, route, router)
  }

  configToSelectItem(name: string, type: string): SelectItem {
    return { label: name, value: type }
  }

  ngOnInit() {
    this.titleService.setAppTitle('Objekte')
    // is this component a top level comp (is this component referenced in the route)?
    const isRouteComp = true
    // will this component provide a custom identifier?
    const hasCustomComponentIdentifier = false
    // initialize pre-ngOnInit-setting for base class.
    this.initNavStateSettings(isRouteComp, hasCustomComponentIdentifier)
    super.ngOnInit()

    const configurations$ = this.entityConfigService.configurations$
    configurations$.subscribe((configs) => {
      if (configs) {
        this.dtoConfigs = Object.values(configs).map((config) => this.configToSelectItem(config.type, config.type))
      }
    })

    this.jmlUrlParamService.readUrlQueryParam$(this.route, 'state').subscribe((value) => {
      if (!value) this.initNavStateSettings(isRouteComp, hasCustomComponentIdentifier)
      super.ngOnInit()
    })

    this.entityType$ = this.jmlUrlParamService.readUrlQueryParam$(this.route, 'type')
    this.entityId$ = this.jmlUrlParamService.readUrlQueryParam$(this.route, 'id').pipe(
      map((value) => +value)
      // tap(id => console.log('url param id changed', id))
    )

    this.entityType$
      .pipe(
        take(1),
        filter((type) => !!type),
        tap((type) => (this.currentConfig = type)),
        tap(() => this.updateView())
      )
      .subscribe()

    this.subscriptions.push(
      this.entityType$
        .pipe(
          filter((type) => type !== this.currentConfig),
          // tap(type => console.log('changing type from query param to: ', type)),
          tap((type) => (this.currentConfig = type)),
          tap(() => this.updateView())
        )
        .subscribe()
    )

    this.subscriptions.push(
      combineLatest([configurations$, this.entityType$, this.entityId$]).subscribe(([configs, type, id]) => {
        this.isDetailView = configs[type]?.viewType === 'multiPage' && !!id
        this.initNavStateSettings(!this.isDetailView, false)
      })
    )
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }

  selectedConfigChanged(event) {
    // current config is set via two-way binding.
    this.jmlUrlParamService
      .setTypeAndId$(this.router, { type: this.currentConfig })
      .pipe(take(1))
      .subscribe(() => {
        this.updateView()
      })
  }

  updateView() {
    this.data = null
    setTimeout(() => {
      this.data = new TableData(this.currentConfig)
    }, 200)
  }
}
